import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@vectord/components';

import {
  isModalOpenSelector,
  setCoursePauseFilterModalState,
} from 'features/courseResume';
import FilterDrawerContent from '../FilterDrawerContent';
import styles from './FilterDrawer.module.scss';

function FilterDrawer() {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(isModalOpenSelector);

  const handleModalClose = useCallback(() => {
    dispatch(setCoursePauseFilterModalState(false));
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={handleModalClose}
      position="right"
      unMountOnClose
      withoutHeader
      className={styles.root}
      containerClassName={styles.containerClassName}
      hasCloseButton={false}
      size="large"
    >
      <FilterDrawerContent />
    </Modal>
  );
}

export default FilterDrawer;
